module.exports = __webpack_public_path__ + "img/bg3.3465ae72.png";